import { render, staticRenderFns } from "./holographic.vue?vue&type=template&id=7089bceb&scoped=true&"
import script from "./holographic.vue?vue&type=script&lang=js&"
export * from "./holographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089bceb",
  null
  
)

export default component.exports